export const SELF_ASSESSMENT_GENERAL_DESCRIPTION_COMPANY = {
  fields: [
    "selfAssessment_general_classification_sector",
    "selfAssessment_general_classification_activityAggregated",
    "selfAssessment_general_classification_activityDetailed",

    "selfAssessment_general_classification_market_international",
    "selfAssessment_general_classification_market_national",
    "selfAssessment_general_classification_market_local",
  ],
};

export const SELF_ASSESSMENT_GENERAL_INFORMATION_SIZE_DIMENTION = {
  fields: [
    "selfAssessment_general_size_numberEmployees",
    "selfAssessment_general_size_revenue",
    "selfAssessment_staff_department_total_women",
    "selfAssessment_staff_department_total_men"
  ],
};

export const SELF_ASSESSMENT_GENERAL_INFORMATION_FINANCIAL_RETURN = {
  fields: [
    "selfAssessment_general_financialReturn_revenue",
    "selfAssessment_general_financialReturn_netIncome",
    "selfAssessment_general_financialReturn_ebitda",
    "selfAssessment_general_financialReturn_roe",
    "selfAssessment_general_financialReturn_roic",
    "selfAssessment_general_financialReturn_rois",
    "selfAssessment_general_financialReturn_noShareholders",
  ],
};

export const SELF_ASSESSMENT_GENERAL_INFORMATION = [].concat(
  SELF_ASSESSMENT_GENERAL_DESCRIPTION_COMPANY.fields,
  SELF_ASSESSMENT_GENERAL_INFORMATION_SIZE_DIMENTION.fields,
  SELF_ASSESSMENT_GENERAL_INFORMATION_FINANCIAL_RETURN.fields
);
